import React, { useState, useRef, useEffect } from 'react';
import classes from './ContextMenu.module.css';
import { componentIdGenerator } from '../@base/@uteis';
import { usePrevious } from '../../utils/hooks';

const ContextMenu = (props) => {
  const id = componentIdGenerator();
  const [showMenu, setshowMenu] = useState(false);
  const prevShowMenu = usePrevious(showMenu);

  const button = React.cloneElement(
    props.button,
    { onClick: () => { setshowMenu(!showMenu); } },
  );

  const node = useRef();

  const handleClickOut = (e) => {
    if (node.current.contains(e.target)) {
      return;
    }
    setshowMenu(false);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOut);
    const reactFlowPane = document.querySelector('.react-flow__pane');
    if (reactFlowPane) reactFlowPane.addEventListener('mousedown', handleClickOut);
    return () => {
      document.removeEventListener('mousedown', handleClickOut);
      const reactPane = document.querySelector('.react-flow__pane');
      if (reactPane) reactPane.removeEventListener('mousedown', handleClickOut);
    };
  }, []);

  useEffect(() => {
    if (!showMenu && prevShowMenu) {
      if (props.clickOut) props.clickOut();
    }
  }, [showMenu]);

  return (
    <>
      <div
        className={`${classes.ContextMenu} ${props.classes || null}`}
        id={id}
        ref={node}
      >
        {button}
        {showMenu
          ? (
            <nav>
              <div
                onClick={() => setshowMenu(props.closeWhenClicked || false)}
                onKeyPress={() => setshowMenu(false)}
                role="button"
                tabIndex="0"
              >
                {props.options}
              </div>

            </nav>
          ) : null}
      </div>
    </>
  );
};

export default ContextMenu;
